/*
 * A Location Utility for providing a React Context so that location and a function
 * to be called when the location changes can be set so that both may be used
 * by multiple and nested components within the Provider.
 */

import React from 'react';
import { object, func } from 'prop-types';

const LocationContext = React.createContext();

const useLocationContext = () => {
  return React.useContext(LocationContext);
};

const getLocation = (ctx) => {
  return ctx?.location;
};

const locationChanged = (ctx, location) => {
  return ctx?.onLocationChange(location);
};

class LocationProvider extends React.Component {
  render() {
    const { location, onLocationChange, children } = this.props;
    const values = {
      location: location,
      onLocationChange: onLocationChange,
    };
    return (
      <LocationContext.Provider value={values}>
        {children}
      </LocationContext.Provider>
    );
  }
}

LocationProvider.propTypes = {
  location: object,
  onLocationChange: func,
  children: object,
};

LocationProvider.defaultProps = {
  location: null,
  onLocationChange: () => {},
};

export { LocationProvider, useLocationContext, getLocation, locationChanged };
